import React, { useState, useEffect } from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import './view.css';

export default function ScrollButton() {
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);


  const handleScroll = () => {
    const scrollY = window.scrollY;
    if (scrollY > 200) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  useEffect(() => {
    
    const blinkTimeout = setTimeout(() => {
      setIsBlinking(true);
    }, 2000);

   
    return () => {
      clearTimeout(blinkTimeout);
     
    };
  }, []);

  return (
    <div>
    {showScrollButton && (
      <button
        onClick={scrollToTop}
        
        style={{
          position: 'fixed',
          bottom: '2px',
          right: '11px',
          padding:'3px',
          color: 'white',
          borderRadius:'5px',
          backgroundColor: 'hsl(255, 93%, 30%)',
          zIndex: '1000',
          border:'none'
         
        }}
      >
       <ArrowDropUpIcon style={{fontSize:'35px'}}/>
      </button>
    )}
    <h1 className="text-white"  style={{
            position: 'fixed',
            padding:'3px', 
            bottom: '130px',
            right: '16px',
            fontSize: '40px',
            zIndex: '1000',
            background:'hsl(255, 93%, 30%)'
            
          
            
          }}>...</h1>
              <a id="mail" href="https://mail.google.com/mail/?view=cm&fs=1&to=buildfortunec2c@gmail.com&su=SUBJECT&body=BODY&"  target="_blank">

<button 
className="btn"
  style={{
    position: 'fixed',
    bottom: '90px',
    right: '10px',
    fontSize:'20px',
    zIndex: '1000',
    cursor: 'pointer',
    background:'hsl(255, 93%, 30%)',
   
   borderRadius:'50%',
  
   
  }}>
    <i class="bi bi-envelope-at text-white"></i>

</button>
</a>
     <a
        href="https://wa.me/9740890386" 
        target="_blank"
        
      >
        <button
          className="btn"
          style={{
            position: 'fixed',
            bottom: '47px',
            right: '10px',
            fontSize: '20px',
            zIndex: '1000',
            cursor: 'pointer',
            backgroundColor: 'rgb(134, 198, 39)', 
            
            borderRadius: '50%',
            
          }}
        >
          <i className="bi bi-whatsapp text-white"></i>
        </button>
      </a>
  

    
  </div>
  );
}
